import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        // "flex min-h-[80px] w-full rounded-md border border-input bg-offwhite px-3 py-2 text-base ring-offset-offwhite placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        // "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-offwhite placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        // "flex min-h-[80px] w-full border border-input bg-background px-3 py-2 text-base ring-offset-offwhite placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "flex min-h-[80px] w-full border border-input bg-background px-3 py-2 text-base ring-offset-offwhite placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-tangarine-400 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
